import { render, staticRenderFns } from "./CreditHistory.vue?vue&type=template&id=5e620fa1"
import script from "./CreditHistory.vue?vue&type=script&lang=js"
export * from "./CreditHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports